<a
  *ngIf="!navigationItem && navigationSection"
  class="navigation-menu__item__container"
  [attr.data-name]="navigationService.navNameTranslation(navigationSection.name)"
  [attr.data-cy]="navigationSection.dataCy + (sectionChildFavorite ? '-favorite' : '')"
  [ngClass]="{
    ' shrinked': isShrinked,
    ' sectionChild': sectionChild,
    ' sectionChildFavorite': sectionChildFavorite,
    ' navigation-menu__item__container--active': selectedSectionValue === navigationSection.type
  }"
  routerLinkActive="navigation-menu__item__container--active"
>
  <div class="navigation-menu__item">
    <div class="navigation-menu__item__content">
      <mat-icon
        class="navigation-menu__item__icon"
        [ngClass]="{
          'navigation-menu__item__icon--active': selectedSectionValue === navigationSection.type,
          'navigation-menu__item__icon--small-icon': navigationSection.type === 'item_and_cribs'
        }"
        matTooltipClass="cm-tooltip typography__tooltip"
        matTooltipShowDelay="500"
        matTooltipPosition="right"
        [matTooltipDisabled]="!isShrinked"
        [matTooltip]="navigationService.navNameTranslation(navigationSection.name)"
        [attr.data-cy]="navigationSection.dataCy + '-icon'"
      >
        {{ navigationSection.iconClass }}
      </mat-icon>
      <span
        routerLinkActive="typography__list-selected"
        class="typography__body-1"
        *ngIf="!isShrinked"
        data-cy="nav-item-icon-name"
      >
        {{ navigationService.navNameTranslation(navigationSection.name) }}
      </span>
    </div>
  </div>
</a>
<ng-container *ngIf="navigationItem && !navigationSection">
  <a
    *visibility="{
      featureFlag: navigationItem.featureFlagModule || null,
      permissionKey: navigationItem.permissionKey || null
    }"
    class="navigation-menu__item__container navigation-menu__item__container--item"
    [attr.data-name]="navigationItem.name | translate | titlecase"
    [attr.data-cy]="navigationItem.dataCy + (sectionChildFavorite ? '-favorite' : '')"
    [ngClass]="{
      'cancel-hover-active': navigationItem.items,
      'hide-parent': navigationItem.items && isShrinked,
      ' shrinked': isShrinked,
      ' favorite': navigationItem.isMarkedAsFavorite,
      ' sectionChild': sectionChild,
      ' sectionChildFavorite': sectionChildFavorite,
      ' navigation-menu__item__container--parent': !isChild
    }"
    routerLinkActive="navigation-menu__item__container--active"
    [routerLink]="navigationItem.routerLink"
    (click)="trackNavigateEvent(navigationItem)"
  >
    <div class="navigation-menu__item" [ngClass]="{ 'navigation-menu__item--child': isChild }">
      <div class="navigation-menu__item__content">
        <mat-icon
          *ngIf="!navigationItem.items && !(sectionChild || sectionChildFavorite)"
          class="navigation-menu__item__icon"
          [ngClass]="{
            'material-icons-outlined': navigationItem.isOutlined,
            'favorite-shrinked': navigationItem.isMarkedAsFavorite && isShrinked,
            'navigation-menu__item__icon--active': selectedSection === navigationItem.routerLink
          }"
          matTooltipClass="cm-tooltip typography__tooltip"
          matTooltipShowDelay="1500"
          matTooltipPosition="right"
          [matTooltipDisabled]="!isShrinked"
          [matTooltip]="navigationService.navNameTranslation(navigationItem.name)"
          [attr.data-cy]="navigationItem.dataCy + '-icon'"
        >
          {{ navigationItem.iconClass }}
        </mat-icon>

        <span
          routerLinkActive="typography__list-selected"
          class="typography__body-1"
          *ngIf="!isShrinked"
          data-cy="nav-item-icon-name"
        >
          {{ navigationService.navNameTranslation(navigationItem.name) }}
        </span>
      </div>
      <mat-icon *ngIf="navigationItem.items && !isShrinked" (click)="onExpand()">
        {{ isExpanded ? 'expand_less' : 'expand_more' }}
      </mat-icon>
      <mat-icon
        *ngIf="!navigationItem.items && !isShrinked && !disableFavorite"
        class="navigation-menu__item__icon navigation-menu__item__icon--favorite"
        matTooltipClass="cm-tooltip typography__tooltip"
        matTooltipPosition="right"
        matTooltipShowDelay="1500"
        matTooltip="{{
          navigationItem.isMarkedAsFavorite
            ? ('navigation.remove-from-favorites' | translate)
            : ('navigation.add-to-favorites' | translate)
        }}"
        (click)="onFavoriteToggle($event)"
        (mousedown)="onFavoriteToggle($event)"
        [attr.data-cy]="navigationItem.dataCy + (navigationItem.isMarkedAsFavorite ? '-stared-icon' : '-not-stared-icon') + (sectionChildFavorite ? '-favorite' : '')"
        svgIcon="{{
          navigationItem.isMarkedAsFavorite ? 'star-filled' : 'star-outlined'
        }}"
      >
      </mat-icon>
    </div>
  </a>
</ng-container>
<a
  *ngIf="favoriteIcon"
  class="navigation-menu__item__container navigation-menu__item__container--favorite"
  [ngClass]="{
    ' shrinked': isShrinked
  }"
  routerLinkActive="navigation-menu__item__container--active"
>
  <mat-icon
    class="navigation-menu__item__icon navigation-menu__item__icon--favorite"
    matTooltipClass="cm-tooltip typography__tooltip"
    matTooltipPosition="right"
    matTooltipShowDelay="1500"
    matTooltip="'Favorites'"
    (click)="openMenu()"
  >
    starrate
  </mat-icon>
</a>
